import { PosIconProps, SvgWrapper } from 'src/svgs/SvgWrapper';

export function ArrowUpIcon7(props: PosIconProps) {
  return (
    <SvgWrapper fill="currentColor" {...props} viewBox="0 0 16 16">
      <path d="M13.5 6L8 .5 2.5 6H7v9h2V6z" />
    </SvgWrapper>
  );
}
